angular.module('iqxCore')
	.controller('AgencyCurrentOpportunitiesCtrl', function ($scope, FormSvc, $httpParamSerializer, $timeout, LanguageSvc, ApiSvc, ApplicationSvc) {
		if (!$scope.checkPermissions('AGENCY')) {
			return
		}
		$scope.selects = {}
		$scope.selects.candidates = []
		$scope.searchRan = false
		$scope.showSearchForm = true
		$scope.searchTerms = {
			"pSearchStartDate": moment().subtract(1, 'week').toDate(),
			"pSearchEndDate": moment().add(1, 'year').toDate()
		}

		FormSvc.setOptions($scope, {
			fetchAPI: 'callresult/NetClientRequirementStatusFilter',
			multiRow: true,
			autoEdit: true,
			fetchTarget: "statuses"
		})
		$scope.fetch()
			.then(function () {
				angular.forEach($scope.statuses, function (value, key) {
					if (value.value == "C") { // we want current as default.
						$scope.searchTerms.pStatus = $scope.statuses[key]
					}
				})
			})

		$scope.ifValDecline = function (val) {
			// fetch the decline reason
			if (val == 'D') {
				return ApiSvc.fetch(
					$scope,
					{
						fetchAPI: 'callresult/NetClientRejectCandidateReason',
						fetchTarget: 'declineReasons',
						multiRow: true
					}
				)
			}
		}

		$scope.humanifyString = function (string) {
			return string
				.replace(/([A-Z])/g, ' $1')
				.replace(/^./, function (str) { return str.toUpperCase() })
		}

		$scope.checkObj = function (search) {
			// Check the dropdown and add it back to the obj
			if ($scope.pStatus) {
				search.pStatus = $scope.pStatus.value
			}

			// Check if something has been typed into either search boxs and add it back to the obj
			if (search.pCompanyName == '' && search.pCompanyName.length == 0) {
				delete search.pCompanyName
			}

			if (search.pPosition == '' && search.pPosition.length == 0) {
				delete search.pPosition
			}

			if (search.pRef == '' && search.pRef.length == 0) {
				delete search.pRef
			}

			return search // TAA DAA!
		}

		$scope.getRequirements = function (search) {
			$scope.showSearchForm = false
			var tempS = search.pStatus
			search.pStatus = search.pStatus.value

			FormSvc.setOptions($scope, {
				fetchAPI: 'callresult/NetAgencyCurrentRequirementSearch?' + $httpParamSerializer(search),
				multiRow: true,
				autoEdit: true,
				sliceSize: 1000000
			})
			$scope.fetch()
				.then(function () {
					$scope.showSearchForm = false
					$scope.searchRan = true
					search.pStatus = tempS
				})
		}

		$scope.addNote = function (data) {
			return ApiSvc.fetch(
				$scope,
				{
					fetchAPI: 'callresult/NetAgencyVacancyNotes?pLineID=' + data.requirement.LineID,
					fetchTarget: 'dbNote',
					multiRow: false
				}
			)
				.then(function () {
					data.requirement.pNotes = $scope.dbNote.pNotes
					FormSvc.modalForm($scope, 'notesDialog', data.requirement, 'md', { label: 'col-sm-3', data: 'col-sm-7' })
						.then(function (xdata) {
							return ApiSvc.fetch(
								$scope,
								{
									fetchAPI: 'call/NetAgencyVacancyNotesUpdate?pLineID=' + data.requirement.LineID + '&pNote=' + encodeURIComponent(xdata.pNotes),
									fetchTarget: 'notes',
									multiRow: false
								}
							)
						})
						.then(function () {
							if ($scope.notes) {
								FormSvc.alert("Success", "Your note has been added.", "success")
							}
						})
				})
		}

		$scope.AcceptDecline = function (data) {
			FormSvc.modalForm($scope, 'acceptDecline', data.requirement, 'md', { label: 'col-sm-3', data: 'col-sm-7' })
				.then(function (xdata) {
					return ApiSvc.fetch(
						$scope,
						{
							fetchAPI: 'call/NetAgencyCurrentRequirementConfirmInterest?pLineID=' + xdata.LineID + '&pTransactionType=' + encodeURIComponent(xdata.xOption) + '&pNote=' + encodeURIComponent(xdata.xNotes) + '&pDeclinedReason=' + xdata.xDeclineReason,
							fetchTarget: 'acceptdecline',
							multiRow: false
						}
					)
				})
				.then(function (rtrn) {
					$scope.successMessage = "The requirement has been actioned."
				})
				.then(function () {
					return $timeout(function () {
						$scope.successMessage = undefined
					}, 5000)
				})
				.finally(function () {
					delete data.requirement.xNotes
					delete data.requirement.xOption
				})
				.catch(function (err) {
					if (err && err != "backdrop click" && err != "escape key press") { ApplicationSvc.showMessage('Error', err, true) }
				})
		}

		$scope.showDialog = function (data) {
			if (!(data.requirement.SubmittedCandidates instanceof Object)) {
				data.requirement.SubmittedCandidates = data.requirement.SubmittedCandidates.split(', ')
			}

			if (data.requirement.SubmittedCandidates[0] == '') {
				delete data.requirement.SubmittedCandidates[0]
			}

			FormSvc.modalInfo($scope, 'CurrentRequirementsView', { requirement: data.requirement, choices: [{ desc: "Close", type: "primary", code: '' }] }, 'md')
		}

		$scope.viewHistory = function (data) {
			var lineid = data.requirement.LineID
			FormSvc.setOptions($scope, {
				fetchAPI: 'callresult/NetAgencyCurrentRequirementAdditionalComments?pLineID=' + lineid,
				multiRow: true,
				autoEdit: true,
				fetchTarget: "history"
			})
			$scope.fetch()
				.then(function () {
					FormSvc.modalInfo($scope, 'notesTable', { history: $scope.history, choices: [{ desc: "Close", type: "primary", code: '' }] }, 'md')
				})
		}

		$scope.submitCandidates = function (data) {
			var lineid = data.requirement.LineID
			$scope.selectedRequirement = data.requirement
			FormSvc.setOptions($scope, {
				fetchAPI: 'callresult/NetAgencyCurrentRequirementCandidates?pLineID=' + lineid,
				multiRow: true,
				autoEdit: true,
				fetchTarget: "candidates"
			})
			$scope.fetch()
				.then(function () {
					return FormSvc.modalForm($scope, 'addCandidate', data, 'md', { label: 'col-sm-3', data: 'col-sm-7' })
						.then(function (xdata) {
							var selectedCaiddate = $scope.candidates[xdata.selected]
							if (!selectedCaiddate) {
								ApplicationSvc.showMessage('Error', "You need to select a candidate", true)
								$scope.response = {}
								$scope.response.pResult = ''
								return true
							}
							if (xdata.action === 'shortlist') {
								$scope.actionMsg = "Booked"
								return ApiSvc.fetch(
									$scope,
									{
										fetchAPI: 'callresult/NetAgencyCurrentRequirementCandidateSubmit?pPersonID=' + selectedCaiddate.PersonID + '&pLineID=' + data.requirement.LineID + '&pNote=' + encodeURIComponent((xdata.xNotes) ? xdata.xNotes : ''),
										fetchTarget: 'response',
										multiRow: false
									}
								)
							} else if (xdata.action === 'book') {
								$scope.actionMsg = "Booked"
								return ApiSvc.fetch(
									$scope,
									{
										fetchAPI: 'callresult/NetAgencyCurrentRequirementCandidateSubmitBook?pPersonID=' + selectedCaiddate.PersonID + '&pLineID=' + data.requirement.LineID + '&pNote=' + encodeURIComponent((xdata.xNotes) ? xdata.xNotes : ''),
										fetchTarget: 'response',
										multiRow: false
									}
								)
							}
						})
						.then(function () {
							if ($scope.response.pResult == '0:~Success') {
								$scope.selects.candidates = {}
								$scope.successMessage = "Candidate " + $scope.actionMsg + " successfully."
							} else {
								throw $scope.response.pResult
							}
						})
						.then(function () {
							return $timeout(function () {
								$scope.successMessage = undefined
							}, 5000)
						})
						.catch(function (err) {
							if (err && err !== "backdrop click" && err != "escape key press") { return ApplicationSvc.showMessage('Error', err, true) }
						})
						.finally(function () {
							delete $scope.candidates
							delete $scope.select.selected
							delete $scope.selects.candidates
							delete $scope.selectedRequirement
						})
				})

		}

		$scope.showSelectAction = function (data) { // when a item is clicked on
			FormSvc.modalInfo($scope, 'showSelectAction', { requirement: data, choices: [{ desc: "Close", type: "primary", code: '' }] }, 'lg')
		}
	})
